// ** React Imports
import { Fragment } from 'react'
import UserDropdown from './UserDropdown';
// ** Custom Components
import NavbarUser from './NavbarUser'

// ** Third Party Components
import { Sun, Moon, Bell, Menu } from 'react-feather'

// ** Reactstrap Imports
import { NavItem, NavLink } from 'reactstrap'
import NavbarBookmarks from './NavbarBookmarks';

import { useSelector } from 'react-redux';

import NavbarDetails from './NavbarDetails';
const ThemeNavbar = props => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props
  const { titleView, detailsParams } = useSelector(state => state.globalConst)
  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }

  return (
    <Fragment>
      <ul className='navbar-nav d-xl-none d-flex align-items-center'>
        <NavItem className='mobile-menu mr-auto'>
          <NavLink className="nav-menu-main menu-toggle hidden-xs is-active"
            onClick={() => setMenuVisibility(true)}>
            <Menu className="" />
          </NavLink>
        </NavItem>
      </ul>
      <span className="fs-1 fw-bolder text-primary ms-1 text-uppercase">{titleView}</span>
      {Object.keys(detailsParams).length !== 0 &&
        <div style={{ width: '55%' }}>
          <NavbarDetails />
        </div>}
      <NavbarUser skin={skin} setSkin={setSkin} />
    </Fragment>
  )
}

export default ThemeNavbar